export default [
  { field: 'name', flex: 2, headerAlign: 'center', headerName: 'Названиe' },
  { field: 'value', flex: 1, align: 'right', headerAlign: 'center', headerName: 'Значение' }
];